import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Badge } from 'taxtank-core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BadgeComponent {
  @Input() badge: Badge;
  // CSS format for width
  @Input() width = '240px';
}
